enum KlaviyoErrorEnum {
  DUPLICATE_PROFILE = "duplicate_profile",
}

export default KlaviyoErrorEnum;
